import { render, staticRenderFns } from "./HistoryItem.vue?vue&type=template&id=38878f4e&scoped=true"
import script from "./HistoryItem.vue?vue&type=script&lang=ts"
export * from "./HistoryItem.vue?vue&type=script&lang=ts"
import style0 from "./HistoryItem.vue?vue&type=style&index=0&id=38878f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38878f4e",
  null
  
)

export default component.exports